import * as React from 'react';

export function useRemoveElementAttribute(
    elementRef: React.MutableRefObject<HTMLDivElement | null>,
    className: string,
    attributeName: string
) {
    React.useEffect(() => {
        const element = elementRef.current;
        if (!element) return;

        const childElement = element.querySelector(`div[class^=${className}]`);

        childElement?.removeAttribute(attributeName);
    }, [attributeName, className, elementRef]);
}
